export default "__VITE_ASSET__fkqM0CZ3__"